import { Button, Popover, PopoverContent, PopoverTrigger } from "@heroui/react";
import { useState } from "react";
import { PencilIcon } from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";

type Mode = "create" | "modify";

type UploadPopoverProps = {
  uploader: (props: { setIsOpen: (open: boolean) => void }) => React.ReactNode;
  mode?: Mode;
  isIconOnly?: boolean;
};

export default function UploadPopover({
  uploader,
  mode = "create",
  isIconOnly = false,
}: UploadPopoverProps) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const label = mode === "create" ? t("actions.new") : t("actions.edit");

  return (
    <Popover
      placement="bottom"
      offset={10}
      isOpen={isOpen}
      onOpenChange={setIsOpen}
    >
      <PopoverTrigger>
        <Button
          type="button"
          isIconOnly={isIconOnly}
          color="primary"
          variant={mode === "create" ? "flat" : "light"}
          size="sm"
          radius="full"
          onPress={() => setIsOpen(true)}
          aria-label={label}
        >
          {mode === "create" ? (
            label
          ) : (
            <PencilIcon className="size-4 text-primary" />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent>{uploader({ setIsOpen })}</PopoverContent>
    </Popover>
  );
}
